module.exports = __webpack_public_path__ + "static/media/banquet_hall.22764d3d.jpg";